<div class="ng-bento">
	<div [bentoBusyLoader]="isLoadingDashboardLayout" class="dashboard-bento-loader"></div>
</div>
<div class="ng-bento client-dashboard-ng" [style]="dashboardStyle">
	<lib-dashboard [customBackground]="background"
								[preferences]="preferences"
								(save)="onSave($event)"
								[isEditable]="isEditable">
		<lib-section sectionId="client-information" [header]="'Bluemoon.Core.ClientDashboard.ClientInformationSectionHeader' | translate" icon="bento-icon-user" *ngIf="this.licenseClientDash">
			<lib-widget [header]="'Core.Captions.Client.ClassOne' | translate" [id]="'client-information-about-widget'">
				<ng-content select="[id='about']"></ng-content>
			</lib-widget>
			<lib-widget [header]="'Onvio.ClientDashboard.StaffAssignments.Header' | translate">
				<ng-content select="[id='staff-relationships']"></ng-content>
			</lib-widget>
			<lib-widget [header]="'Core.Captions.Contact.ClassOther' | translate">
				<ng-content select="[id='related-contacts']"></ng-content>
			</lib-widget>
			<lib-widget id="confirmations-container" [header]="'Onvio.ClientDashboard.Confirmations.Header' | translate" *ngIf="canShowConfirmationsWidget()">
				<app-confirmation-requests></app-confirmation-requests>
			</lib-widget>
			<lib-widget
				id="fm-dashboard-widget"
				*ngIf="!accessFmDashboardCustomFieldsWidget && currentCountry !== 'BR'  && hasCustomFieldLicense"
				[header]="'Onvio.ClientDashboard.CustomFields.Header.New' | translate"
			>
			<app-widget-dashboard-layout [client]="client"></app-widget-dashboard-layout>
		</lib-widget>

			<lib-widget id="client-comments" [header]="'Onvio.ClientDashboard.ClientComments.Header' | translate">
				<ng-content select="[id='comments']"></ng-content>
			</lib-widget>
		</lib-section>

		<lib-section sectionId="projects-tasks" [header]="'Onvio.ClientDashboard.ClientAssignments.Header.ProjectsAndTasks' | translate" icon="bento-icon-folder-open" *ngIf="this.licenseClientDash">
			<lib-widget id="projects-tasks" [header]="'onvio.clientTaskWidget.header' | translate">
				<app-client-task-widget [client]="client"></app-client-task-widget>
			</lib-widget>
			<lib-widget id="client-assignments-widget-container" [header]="getClientAssignmentsWidgetHeaderText()" *ngIf="this.licenseClientDash && this.hasProjectsFRP">
				<ng-content select="[id='my-assignments']"></ng-content>
			</lib-widget>
		</lib-section>

		<lib-section sectionId="on-balance" [header]="'Onvio.ClientDashboard.Navigation.Onbalance' | translate"
								icon="bento-icon-report"
								*ngIf="licenseOnbalanceLinking">
			<lib-widget *ngIf="accessOnBalance"
									[header]="'Onvio.Reports.ClientDashboard.AccessClientInOnbalance' | translate"
									[hideCard]="true">
				<ng-content select='[id="client-button"]'></ng-content>
			</lib-widget>
			<lib-widget *ngIf="!isLinkedToOnBalance"
									[header]="'Onvio.ClientDashboard.Navigation.Onbalance' | translate"
									[hideCard]="true">
				<div class="notification-container">
					<div class="alert alert-info">
						<p>{{ 'Bluemoon.Core.ClientDashboard.OnBalanceNotEnabledForClient' | translate: { ClientName: client?.primaryContactExpanded?.displayAs } }}</p>
					</div>
				</div>
			</lib-widget>
			<lib-widget *ngIf="isLinkedToOnBalance"
									[header]="'BlueMoon.Accounting.Components.Notifications' | translate">
				<ng-content select="notifications"></ng-content>
			</lib-widget>
			<lib-widget [header]="'Onvio.Reports.ClientDashboard.QuarterlyReportStatements' | translate"
									*ngIf="accessQuarterReport && isSimpleTaxPayer && isLinkedToOnBalance">
				<ng-content select="quarter-report-statements-ar"></ng-content>
			</lib-widget>
		</lib-section>

		<lib-section sectionId="time-billing" [header]="'Onvio.ClientDashboard.Navigation.TimeAndBilling' | translate" icon="bento-icon-clock" *ngIf="showTimeAndBillingWidgets()">
			<lib-widget [header]="'Bluemoon.Practice.Widget.WIPSummary.Title' | translate" *ngIf="licenseTimeAndExpense">
				<ng-content select='[id="wip-summary"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.ARSummary.Title' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="ar-summary"]'></ng-content>
			</lib-widget>
			<lib-widget header="{{ 'Bluemoon.Practice.Widget.Agings.WIP' | translate }} {{ 'Bluemoon.Practice.Widget.Agings.Title' | translate }}" *ngIf="licenseBilling">
				<ng-content select='[id="wip-agings"]'></ng-content>
			</lib-widget>
			<lib-widget header="{{ 'Bluemoon.Practice.Widget.Agings.AR' | translate }} {{ 'Bluemoon.Practice.Widget.Agings.Title' | translate }}" *ngIf="licenseBilling">
				<ng-content select='[id="ar-agings"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.KeyTotals.Title' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="key-totals"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.PriorInvoices.Title' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="prior-invoices"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.AccountsReceivableOpen.Titleems' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="ar-open"]'></ng-content>
			</lib-widget>
		</lib-section>

	</lib-dashboard>
</div>
